import * as actions from "./actions";
import update from "immutability-helper";

let initialState = {
  applications: {
    fetched: false,
    fetching: false,
    data: {},
  },
  creditApplications: {
    fetched: false,
    fetching: false,
    data: {},
  },
  loans: {
    fetched: false,
    fetching: false,
    data: {},
  },
};

const userCreditHistory = (state = initialState, action) => {
  switch (action.type) {
    case actions.USER_CREDIT_HISTORY_GET_REQUEST:
      return update(state, {
        applications: { fetching: { $set: true }, fetched: { $set: false } },
        loans: { fetching: { $set: true }, fetched: { $set: false } },
        creditApplications: {
          fetching: { $set: true },
          fetched: { $set: false },
        },
      });
    case actions.USER_CREDIT_HISTORY_LOAN_GET_SUCCESS:
      return update(state, {
        loans: {
          fetching: { $set: false },
          fetched: { $set: true },
          data: {
            $set: { [action.dataSent.accountId]: action.response.Response },
          },
        },
      });
    case actions.USER_CREDIT_HISTORY_APPLICATION_GET_SUCCESS:
      return update(state, {
        applications: {
          fetching: { $set: false },
          fetched: { $set: true },
          data: { $set: { [action.dataSent.accountId]: action.response } },
        },
      });
    case actions.USER_CREDIT_HISTORY_CREDIT_APPLICATION_GET_SUCCESS:
      return update(state, {
        creditApplications: {
          fetching: { $set: false },
          fetched: { $set: true },
          data: { $set: { [action.dataSent.accountId]: action.response } },
        },
      });
    default:
      return state;
  }
};

export default userCreditHistory;
